// extracted by mini-css-extract-plugin
export default {"img_container":"imageRB_img_container__6Q9NR"};